export default __webpack_public_path__ + "static/media/brand2.848038e1.png";